import { makeGatePage } from '../components/app-gate/gatePage'
import { gateStaticProps } from '../components/app-gate/gateStaticProps'

export const getStaticProps = gateStaticProps

export default makeGatePage({ gateKey: 'myGym', ticks: 3 })
